<template>
  <v-data-table
    v-model="selectedBody2Cars"
    :headers="headers"
    :items="body2Cars"
    :search="search"
    :loading="isTableLoading"
    item-key="id"
    selectable-key="isSelectable"
    single-select
    show-select
    multi-sort
    show-expand
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-dialog
          v-model="dialogUploadVisible"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              class="m-2"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left>
                mdi-car
              </v-icon>
              新增
            </v-btn>
          </template>
          <v-form>
            <v-card ref="form">
              <v-card-title>
                <span class="headline">新增身障車</span>
              </v-card-title>
              <v-card-text>
                <v-text-field v-model="newBody2Car.licensePlate" label="車牌 (範例:ABC-123)"></v-text-field>
                <v-text-field v-model="newBody2Car.code" label="識別證編號"></v-text-field>
                <v-text-field v-model="newBody2Car.issueUnit" label="發證單位"></v-text-field>
                <v-text-field v-model="newBody2Car.issueDate" label="核發日期 (範例:20240501)"></v-text-field>
                <v-text-field v-model="newBody2Car.expiredAt" label="有效期限 (範例:20240501)"></v-text-field>
                <v-file-input v-model="newBody2Car.image" accept="image/*" label="照片" truncate-length="15"></v-file-input>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  @click="dialogUploadVisible = false"
                >
                  取消
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  @click="uploadBody2"
                >
                  送出
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog
          v-model="dialogDeleteVisible"
          max-width="290px"
        >
          <v-card>
            <v-card-title class="text-h5">
              確認是否刪除身障車?
            </v-card-title>
            <v-card-text>
              1. 自訂身障車牌於每晚凌晨同步至政府端
              <br>
              2. 只能刪除我方系統內的身障車, 無法對政府端資料進行刪除
              <br>
              3. 若被刪除的車牌已上傳至政府端, 則只是從當前系統內暫存的身障名單中刪除, 但次日身障同步時將被再次加回!
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                text
                @click="dialogDeleteVisible = false"
              >
                取消
              </v-btn>
              <v-btn
                color="error"
                text
                @click="deleteBody2"
              >
                送出
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn
          color="primary"
          class="m-2"
          @click="loadBody2"
        >
          <v-icon left>
            mdi-refresh
          </v-icon>
          更新
        </v-btn>
        <v-btn
          color="error"
          class="m-2"
          :disabled="selectedBody2Cars.length === 0"
          @click="dialogDeleteVisible=true"
        >
          <v-badge
            :content="selectedBody2Cars.length"
            :value="selectedBody2Cars.length"
            color="error"
          ><v-icon left>
              mdi-delete
            </v-icon>
            刪除
          </v-badge>
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          clear-icon="mdi-close-circle"
          label="Search"
          clearable
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:[`item.data-table-select`]="{ isSelected, select, item }">
      <v-simple-checkbox
        :value="isSelected"
        :off-icon="item.isSelectable ? '$vuetify.icons.checkboxOff': 'mdi-block-helper'"
        :disabled="!item.isSelectable"
        @input="select($event)"
      />
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <img :src="item.image">
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  data() {
    return {
      valid: false,
      body2Cars: [],
      selectedBody2Cars: [],
      newBody2Car: {
        licensePlate: '',
        code: '',
        issueUnit: '',
        issueDate: '',
        expiredAt: '',
        image: ''
      },
      dialogDeleteVisible: false,
      dialogUploadVisible: false,
      isTableLoading: false,
      search: '',
      headers: [
        {
          text: '車牌',
          value: 'licensePlate',
          width: '20%',
        },
        {
          text: '代碼',
          value: 'code',
          width: '20%',
        },
        {
          text: '發證單位',
          value: 'issueUnit',
          width: '10%',
        },
        {
          text: '核發日期',
          value: 'issueDate',
          width: '10%',
        },
        {
          text: '有效期限',
          value: 'expiredAt',
          width: '10%',
        },
        {
          text: '登記日期',
          value: 'date',
          width: '10%',
        },
        {
          text: '上傳狀態',
          value: 'isUploaded',
          width: '10%',
        }
      ],
    }
  },

  computed: {
  },

  watch: {
    dialogUploadVisible(visible) {
      if (!visible) {
        this.$refs.form.reset();
      }
    }
  },

  created () {
    this.loadBody2();
  },

  methods: {
    getBase64(file) {
      return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result.split(',')[1]);
          reader.onerror = (error) => reject(error);
      });
    },
    loadBody2() {
      this.isTableLoading = true;
      this.licensePlates = [];
      this.axios.get('api/custom/otherbdy')
        .then((resp) => {
          this.body2Cars = [];
          resp.data.forEach(item => {
            this.body2Cars.push({
              id: item.id,
              licensePlate: item.licensePlate,
              code: item.code,
              issueUnit: item.issueUnit,
              issueDate: item.issueDate,
              expiredAt: item.expiredAt,
              isUploaded: item.isUploaded,
              date: this.$moment(item.date).format('YYYY-MM-DD'),
              image: item.image.replace('/public', ''),
              isSelectable: true,
            });
          });
        })
        .catch(err => alert(err))
        .then(() => this.isTableLoading = false);
    },
    async uploadBody2() {
      if (!this.newBody2Car.licensePlate) {
        alert('車牌不得為空');
        return;
      }

      if (!this.newBody2Car.code) {
        alert('識別證編號不得為空');
        return;
      }

      if (!this.newBody2Car.issueUnit) {
        alert('核發單位不得為空');
        return;
      }

      if (this.newBody2Car.issueDate && !this.$moment(this.newBody2Car.issueDate, "YYYYMMDD", true).isValid()) {
        alert('核發日期錯誤');
        return;
      }

      if (!this.$moment(this.newBody2Car.expiredAt, "YYYYMMDD", true).isValid()) {
        alert('有效期限錯誤');
        return;
      }

      if (!this.newBody2Car.image) {
        alert('缺少照片');
        return;
      }
      
      this.dialogUploadVisible = false;
      const data = {
        licensePlate: this.newBody2Car.licensePlate,
        code: this.newBody2Car.code,
        issueUnit: this.newBody2Car.issueUnit,
        issueDate: this.newBody2Car.issueDate,
        expiredAt: this.newBody2Car.expiredAt,
        imageBase64: await this.getBase64(this.newBody2Car.image),
      };

      this.axios.post('api/custom/otherbdy', data)
        .then(() => this.loadBody2())
        .catch((err) => alert(err.response? err.response.data.message: err));
    },
    deleteBody2() {
      const id = this.selectedBody2Cars[0].id;

      this.axios.delete(`api/custom/otherbdy/${id}`)
        .then(() => this.loadBody2())
        .catch((err) => alert(err.response? err.response.data.message: err))
        .then(() => {
          this.dialogDeleteVisible=false;
          this.selectedBody2Cars = [];
        });
    },
  },
}
</script>
